// extracted by mini-css-extract-plugin
export var background = "styles-module--background--34da8";
export var image = "styles-module--image--98498";
export var text = "styles-module--text--bbb96";